// src/components/EmailFilter.js
import React, { useState } from 'react';
import { Form, Card, Row, Col, Button } from 'react-bootstrap';

const EmailFilter = ({ onFilterChange, defaultEmails = ['demo-user@balanceflo.com', 'demo-admin@balanceflo.com'] }) => {
  const [emails, setEmails] = useState(defaultEmails.join('\n'));
  const [caseInsensitive, setCaseInsensitive] = useState(false);
  
  // Handle filter application
  const applyFilter = () => {
    // Split emails by newline and trim each one
    const emailList = emails
      .split('\n')
      .map(email => email.trim())
      .filter(email => email.length > 0);
      
    // Send filter options to parent component
    onFilterChange({
      emails: emailList,
      caseInsensitive
    });
  };

  return (
    <Card className="mb-4">
      <Card.Header>Email Filter</Card.Header>
      <Card.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Target Emails (One per line)</Form.Label>
            <Form.Control 
              as="textarea" 
              rows={3}
              value={emails}
              onChange={(e) => setEmails(e.target.value)}
            />
          </Form.Group>
          
          <Row>
            <Col>
              <Form.Check 
                type="checkbox"
                id="case-insensitive-checkbox"
                label="Case-insensitive matching"
                checked={caseInsensitive}
                onChange={(e) => setCaseInsensitive(e.target.checked)}
              />
            </Col>
            <Col className="text-end">
              <Button variant="primary" onClick={applyFilter}>
                Apply Filter
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default EmailFilter;